(function () {
	'use strict';

	/**
	 * This factory creates an HTTP interceptor for timing requests in AngularJS.
	 */
	angular
		.module('dcApp') // Make sure this module name matches your app's module
		.factory('TimingInterceptor', TimingInterceptor);

	// Inject $q for handling promise rejection and $log for logging
	TimingInterceptor.$inject = ['$q', 'LoggerFactory'];

	function TimingInterceptor($q, LoggerFactory) {
		const logger = LoggerFactory.getLogger('TimingInterceptor', false);
		return {
			/**
			 * Intercepts the request config before it's sent.
			 * This is where we start the timer.
			 */
			request: function (config) {
				// Store the start time directly on the request config object
				if (!config.url.includes('.html')) {
					config.startTime = performance.now();
				}
				return config;
			},

			/**
			 * Intercepts a successful response.
			 * This is where we stop the timer and log the success.
			 */
			response: function (response) {
				// Check if we set a start time on this request
				if (response.config.startTime) {
					var endTime = performance.now();
					var duration = endTime - response.config.startTime;

					logger.debug(
						`${response.config.method} ${
							response.config.url
						} | Took: ${duration.toFixed(2)} ms`
					);
				}
				// Return the response or a promise for it
				return response;
			},

			/**
			 * Intercepts a failed response (error).
			 * This is where we stop the timer and log the error.
			 */
			responseError: function (rejection) {
				// Check if we set a start time on this request
				if (rejection.config.startTime) {
					var endTime = performance.now();
					var duration = endTime - rejection.config.startTime;

					logger.error(
						`${rejection.config.method} ${
							rejection.config.url
						} | Took: ${duration.toFixed(2)} ms`
					);
				}

				// Important: You must reject the promise to continue the error chain
				return $q.reject(rejection);
			},
		};
	}

	angular.module('dcApp').config([
		'$httpProvider',
		function ($httpProvider) {
			$httpProvider.interceptors.push('TimingInterceptor');
		},
	]);
})();
